// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as LogOutADefault } from '../../../assets/icons/default/general/log-out-a.svg?react';
import { ReactComponent as LogOutASolid } from '../../../assets/icons/solid/general/LOG-OUT-A.svg?react';
import { createIcons } from '../../Icon';
const LogOutAIcon = /* @__PURE__ */ createIcons('LogOutA', {
    default: LogOutADefault,
    solid: LogOutASolid
});
LogOutAIcon.supportedTypes = ['default', 'solid'];
LogOutAIcon.category = 'general';
export default LogOutAIcon;
